
export const TopMoversCard = ({ topMovers }) => {

    return (
        <div>
            <h6 className="text-align-center">Top Movers</h6>
            {
                topMovers?.map((mover, index) => {
                    return (
                        <div className="d-flex justify-content-between small" key={index}>
                            <span className="lines-1">{mover?.exercise?.exerciseName}</span>
                            <span className={`lines-1 ${(mover?.change > 0 ? 'green-mover' : 'red-mover')}`}>{mover?.change?.toFixed(1)}%</span>
                        </div>
                    )
                })
            }
        </div>
    )
}